{
  "version": 1,
  "asset_id": "67624035-7049-4adf-ab63-a7317758865d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/67624035-7049-4adf-ab63-a7317758865d/loc-the-woodlands-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/67624035-7049-4adf-ab63-a7317758865d/loc-the-woodlands-640.webp",
  "original_filename": "loc-the-woodlands-640.webp",
  "size": 27112,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:34Z"
}
